module.exports = __webpack_public_path__ + "img/GAME_NUMBER1.a8db1295.jpg";